import { render, staticRenderFns } from "./Addresses.vue?vue&type=template&id=cddd74fc&scoped=true&lang=html&"
import script from "./Addresses.vue?vue&type=script&lang=js&"
export * from "./Addresses.vue?vue&type=script&lang=js&"
import style0 from "./Addresses.vue?vue&type=style&index=0&id=cddd74fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cddd74fc",
  null
  
)

export default component.exports